import { render } from "./mvt-attribute.vue?vue&type=template&id=43f0d740"
import script from "./mvt-attribute.vue?vue&type=script&lang=js"
export * from "./mvt-attribute.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__